import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Location } from './location';
import { LocationType } from './location-type';
import { LocationService } from './location.service';
import { LocationTypeService } from './location-type.service';
import { Area } from '../location/area';
import { AreaService } from '../location/area.service';

import { Message, ConfirmationService, SelectItem } from 'primeng/primeng';

@Component({
  selector: 'app-location',
  templateUrl: './location.component.html',
  styleUrls: ['./location.component.css'],
  providers: [ConfirmationService]
})
export class LocationComponent implements OnInit {

  locationList: Location[];
  msgs: Message[];
  selectedLocation: Location;
  area: Area;
  areaId: number;
  locationTypeList: SelectItem[];

  constructor(private locationService: LocationService, private router: Router,
    private confirmationService: ConfirmationService,
    private areaService: AreaService, private route: ActivatedRoute,
    private locationTypeService: LocationTypeService) {
    this.locationList = [];
    this.msgs = [];
    this.area = new Area();
    this.selectedLocation = new Location();
  }

  ngOnInit() {

    if (this.route.snapshot.params['id'] != null) {
      this.areaId = +this.route.snapshot.params['id'];
      this.areaService.qryArea(+this.route.snapshot.params['id']).subscribe(
        (area: Area) => {
          if (area != null) {
            this.area = area;
          } else {
            this.msgs.push({ severity: 'warn', summary: 'Failed to load location.' });
          }
        },
        (err) => {
          this.msgs = [];
          this.msgs.push({ severity: 'warn', summary: 'Failed to load location.' })
        }
      );
    }

    this.loadLocationTypes();
    this.loadLocations();
  }

  private loadLocations() {
    if (this.area != null) {
      this.locationService.listLocationsInArea(this.areaId).subscribe(
        (locationArray: Location[]) => {
          this.locationList = [];
          for (var location of locationArray){
            this.locationList = [...this.locationList, location];
          }
        },
        (err) => {
          console.log(err);
          this.msgs = [];
          this.msgs.push({ severity: 'warn', summary: 'Error', detail: 'Could not load list of locations.' });
        }
      );
    }
  }

  private loadLocationTypes() {
    this.locationTypeList = [];
    this.locationTypeService.list().subscribe(
      (locationTypeArray: LocationType[]) => {
        this.locationTypeList = [];
        for (var locationType of locationTypeArray)
          this.locationTypeList.push({label : locationType.name, value: locationType});
      },
      (err) => {
        console.log(err);
        this.msgs = [];
        this.msgs.push({ severity: 'warn', summary: 'Error', detail: 'Could not load list of locationTypes.' });
      }
    );
  }

  /**
   * Loads location generator for this area
   */
  public navigateToGenerator() {
    this.router.navigate(['area','locations','generate',this.area.id]);
  }

  public addNew() {
    console.log('Create new Location.');

    /**
     * We need to check first, if there is already a new instance
     * in list of areas.
     */
    for (var a of this.locationList) {
      if (a.id < 0) {
        this.selectedLocation = a;
        this.msgs.push({ severity: 'info', summary: 'Erst neuen Platz speichern.' });
        return;
      }
    }

    let location = new Location();
    location.id = -1;
    location.area = this.area;
    location.barcode = "";
    location.capacityFree = 1;
    location.capacityMax = 1;
    location.capacityUsed = 0;
    location.loadMax = 999;
    location.loadFree = 999;
    location.loadUsed = 0;
    location.created = new Date();
    location.updated = new Date();

    this.locationList = [...this.locationList, location];
    this.selectedLocation = location;
  }

  /**
   * Navigate to details component
   */
  public editSelected() {
    if (this.selectedLocation == null) {
      this.msgs = [];
      this.msgs.push({ severity: 'info', summary: 'Keine Platz ausgewaehlt.' });
      return;
    }

    this.router.navigate(['/location', this.selectedLocation.id])
  }

  public deleteSelected() {
    this.msgs = [];
    if (this.selectedLocation == null) {
      this.msgs.push({ severity: 'info', summary: 'Kein Platz ausgewaehlt.' });
      return;
    }
    this.confirmationService.confirm({
      message: 'Moechten Sie den Platz wirlich loeschen?',
      accept: () => {
        this.locationService.delete(this.selectedLocation.id).subscribe(
          (success: any) => {
            if (success != null && success.success) {
              this.msgs.push({ severity: 'info', summary: 'Platz wurde geloescht.' });
              this.loadLocations();
            } else {
              this.msgs.push({ severity: 'warn', summary: 'Platz konnte nicht geloescht werden.' });
              console.log('Error on serverside.');
            }
          },
          (err) => {
            this.msgs.push({ severity: 'warn', summary: 'Platz konnte nicht geloescht werden.' });
            console.log(err);
          }
        );
      }
    });

  }

  /**
   * Saves or updates edited location entity to server.
   */
  public onSave() {
    if (this.selectedLocation == null || this.selectedLocation.id == null)
      this.msgs.push({ severity: 'info', summary: 'Please add or selected an location first.' });

    if (this.selectedLocation.id == -1) {
      this.locationService.save(this.selectedLocation).subscribe(
        (res) => {
          let msg: Message = { severity: 'info', detail: 'Der Platz wurde gespeichert.', summary: 'Gespeichert!' };
          this.msgs = [];
          this.msgs.push(msg);
          this.loadLocations();
        },
        (err) => {
          let msg: Message = { severity: 'warn', detail: 'Der Platz konnte nicht gespeichert werden.', summary: 'Fehler!' };
          this.msgs = [];
          this.msgs.push(msg);
          console.log('Could not save location, error msg: ' + err);
        }
      );
    }
    else {
      this.locationService.update(this.selectedLocation).subscribe(
        (res) => {
          let msg: Message = { severity: 'info', detail: 'Der Platz wurde gespeichert.', summary: 'Gespeichert!' };
          this.msgs = [];
          this.msgs.push(msg);
          this.loadLocations();
        },
        (err) => {
          let msg: Message = { severity: 'warn', detail: 'Der Platz konnte nicht gespeichert werden.', summary: 'Fehler!' };
          this.msgs = [];
          this.msgs.push(msg);
          console.log('Could not save location, error msg: ' + err);
        }
      );
    }
  }
}


// WEBPACK FOOTER //
// /home/pneuser/workspace/pepelogistic/pepeLogisticControl/src/app/location/location.component.ts